import React, {Component} from 'react';
import {FastLayer, Image} from 'react-konva';
import './stage.css';

/** @class ParallaxLayer
 * An image that scrolls at a different speed than
 * the stage, creating an illusion of depth.
 */
export default class ParallaxLayer extends Component {
  /** @constructor
    * Constructs a new instance of ParallaxLayer
    * @prop {url} image - the image to display
    * @prop {number} scale - the scale of the layer relative to the stage;
    * this simulates depth by scaling the image size and scrolling
    * @prop {number} width - the width of the stage
    * @prop {number} height - the height of the stage
    * @prop {number} scrollLeft - the distance the stage is scrolled horizontally
    * @prop {number} scrollTop - the distance the stage is scrolled vertically
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
    this.scrollTo = this.scrollTo.bind(this);
  }
  /** @method componentDidMount
    * Loads the image.
    */
  componentDidMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.image;
  }
  /** @method scrollTo
    * Scrolls the ParallaxLayer to the specified position,
    * scaled to emulate depth
    */
  scrollTo(x, y, duration) {
    if(duration > 0) {
      this.layer.to({
        x: -x * (1 - this.props.scale),
        y: -y * (1 - this.props.scale),
        duration: duration
      });
    } else {
      this.layer.position({
        x: -x * (1 - this.props.scale),
        y: -y * (1 - this.props.scale)
      });
    }
  }
  /** @function
   * Renders the image sized and scrolled to emulate depth.
   */
  render() {
    return (
      <FastLayer ref={el => {this.layer = el}}
        x={this.props.scrollLeft * (1 - this.props.scale)}
        y={this.props.scrollTop * (1 - this.props.scale)}
      >
        <Image
          image={this.state.image}
          width={this.props.width}
          height={this.props.height}
          transformsEnabled="position"
          />
      </FastLayer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/stage/parallax-layer.js